import { refreshAuth } from './requests/auth/user';
import axios from 'axios';
import { CONNECT_BE_URI, AUTH_REFRESH_URI } from 'shared/consts/config';
import { router, routeBuilder } from 'shared/router';
import { redirectCognito } from 'shared/utils/auth';
import { stringify } from 'shared/utils/params';

const client = axios.create({
  baseURL: CONNECT_BE_URI,
  paramsSerializer: { serialize: (params) => stringify(params) },
  withCredentials: true,
});

client.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    const originalConfig = error.config;

    if (error.response?.status === 403) {
      // Unauthorized, redirect to error page
      router.navigate(routeBuilder.error(403));
      return Promise.reject(error);
    }

    if (originalConfig.url === AUTH_REFRESH_URI && error.response?.status === 401) {
      // Not able to renew token, redirect to login
      redirectCognito();
      return Promise.reject(error);
    }

    if (originalConfig.url !== AUTH_REFRESH_URI && error.response) {
      // Access Token was expired
      if (error.response?.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          await refreshAuth();
          return client(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export const restClient = client;
